import assetPath from '/app/xinglets/career-hub/bewerbung-topic-page/src/bewerbung-topic-page/heading-section/assets/logo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')